import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiGrid, FiList } = FiIcons;

const ViewModeToggle = ({ viewMode, onViewModeChange }) => {
  const modes = [
    {
      id: 'focus',
      label: 'Focus',
      icon: FiGrid,
      description: 'โหมดโฟกัส - แสดงแบบการ์ด เหมาะสำหรับภาพรวม'
    },
    {
      id: 'pro',
      label: 'Pro',
      icon: FiList,
      description: 'โหมดโปร - แสดงแบบตาราง เหมาะสำหรับวิเคราะห์ข้อมูล'
    }
  ];

  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm text-gray-600 mr-2">โหมดแสดงผล:</span>
      <div className="flex bg-gray-100 rounded-lg p-1">
        {modes.map((mode) => (
          <motion.button
            key={mode.id}
            onClick={() => onViewModeChange(mode.id)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${
              viewMode === mode.id
                ? 'bg-white text-blue-600 shadow-sm'
                : 'text-gray-600 hover:text-gray-800'
            }`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            title={mode.description}
          >
            <SafeIcon icon={mode.icon} className="h-4 w-4" />
            <span>{mode.label}</span>
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export default ViewModeToggle;